const unionBy = (array, iteratee) => {
  const map = new Map()
  array.forEach((object) => {
    map.set(object[iteratee], object)
  })

  return [...map.values()]
}

export default unionBy
